export default {
  buttonOfTableTop: {
    type: Boolean,
    default: false,
  },
  idPrefix: {
    type: String,
    default: 'keywordSearchTable',
  },
  index: {
    type: Boolean,
    default: true,
  },
  value: {
    type: [Object, Array, String],
    //  default:()=>{  return {id:null,code:null,name:null}  }
  },
  requestMethod: {
    type: String,
    default: 'post',
  },
  // 请求参数,json格式或者对象
  requestParam: {
    type: [String, Object],
    default: null,
  },
  searchKey: {
    type: String,
    default: 'keyword',
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  tableColumnDef: {
    type: Array,
    default: () => {
      return [
        {
          prop: 'code',
          label: '编码',
        },
        {
          prop: 'name',
          label: '名称',
        },
      ]
    },
  },
  placeholder: {
    type: String,
    default: '关键字',
  },
  url: {
    type: String,
    default: '',
  },
  field: {
    type: String,
    default: '',
  },
  isParameters: {
    type: Boolean,
    default: false,
  },
  tableRowMenuItem: {
    type: Array,
    default: () => {
      return [
        {
          icon: 'ivu-icon-icon-pg-operation',
          name: '编辑地址库信息',
          type: 'edit',
          style: '',
        },
        {
          icon: 'ivu-icon-icon-pg-operation',
          name: '删除',
          type: 'remove',
          style: 'error',
        },
      ]
    },
  },
  operateCellOfTableRow: {
    type: Boolean,
    default: false,
  },
  modalFormBodyBgc: {
    type: Boolean,
    default: false,
  },
  modalFormWidth: {
    type: [String, Number],
    default: '340',
  },
  urlSaveForModalForm: {
    type: String,
    default: '',
  },
  urlRemoveForRow: {
    type: String,
    default: '',
  },
  urlModalFormItemsDef: {
    type: String,
    default: '',
  },
  urlGetOfEditForModalForm: {
    type: String,
    default: '',
  },
  maskClosable: {
    type: Boolean,
    default: true,
  },
  modalFromTitle: {
    type: String,
    default: '提示',
  },
  height: {
    type: [String, Number],
  },
  // 列定义支持简单转换 20191029 lqn
  formatterObj: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  pageSizeOption: {
    type: Array,
    default: () => [10, 20, 30, 40],
  },
  pageSize: {
    type: Number,
    default: 10,
  },
  defaultKeyWord: {
    type: String,
    default: '',
  },
}
